import { BlobServiceClient } from "@azure/storage-blob";

export const GetBlockBlobCLient = (path: string) => {
    const blobServiceClient = new BlobServiceClient(process.env.REACT_APP_AZURE_BLOB_SASS_URL as string)
    const containerClient = blobServiceClient.getContainerClient(process.env.REACT_APP_AZURE_BLOB_CONTAINER_NAME as string)
    const blockBlobClient = containerClient.getBlockBlobClient(path)
    return blockBlobClient
}

export const Get = async (path: string) => {
    const block_blob_client = GetBlockBlobCLient(`${path}.json`)
    const result = await block_blob_client.download();
    const blob = await result.blobBody as Blob;
    return JSON.parse(await blob.text())
}

export const Set = async (path: string, data: any) => {
    const block_blob_client = GetBlockBlobCLient(`${path}.json`)
    const _data = JsonToBlob(data)
    await block_blob_client.uploadData(_data, { blobHTTPHeaders: { blobContentType: _data.type } })
}

export const GetAssetUrl = (path: string) => {
    const blockBlobClient = GetBlockBlobCLient(path)
    return blockBlobClient.url
}

export const Base64ToBlob = (data: string) => {
    const parts = data.split(';base64,')
    const imageType = parts[0].split(':')[1]
    const decodedData = window.atob(parts[1])
    const uInt8Array = new Uint8Array(decodedData.length)
    for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i)
    }
    return new Blob([uInt8Array], { type: imageType })
}

export const JsonToBlob = (data: any) => {
    const str = JSON.stringify(data);
    const bytes = new TextEncoder().encode(str);
    const blob = new Blob([bytes], {
        type: "application/json;charset=utf-8"
    });
    return blob
}

export const UrlToBase64 = async (url: string) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        }
    });
}

export const FileToArrayBuffer = (file: File) => {
    return new Promise((resolve, reject) => {
        const reader: FileReader = new FileReader();
        reader.onload = () => {
            const array_buffer = new Uint8Array(reader.result as ArrayBuffer);
            resolve(array_buffer)
        }
        reader.onerror = (e) => {
            reject(e)
        }
        reader.readAsArrayBuffer(file);
    })
}

export const GenerateCode = (len: number) => {
    const a: any = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
    const b = [];
    for (let i = 0; i < len; i++) {
        const j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
    }
    return b.join("");
}